import { roundValue, safeParseFloat } from "lib/number";
import { MetricsKind } from "../types";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { getChildrenUnits } from "../column-formula/units";
import { MetricsTotalType } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { getDeliveriesFromAllocationDimension } from "helpers/allocation-dimension";

export const AVERAGE_UNITS = ({ factoryOptions, getterParams }) => {
    const { doors, totalType, disableSiblingOptimization } = factoryOptions;
    let totalLength = doors.length;

    const totalUnits = referenceMetricValueOrCompute(
        () => {
            let totalUnits = 0;
            getterParams.api.forEachNodeAfterFilter((rowNode) => {
                // We only need to include outer row. `getChildrenUnits` will count nested children
                if (rowNode.level === 0) {
                    totalUnits += getChildrenUnits(factoryOptions, {
                        ...getterParams,
                        node: rowNode,
                        data: rowNode.data,
                    });
                }
            });

            return totalUnits;
        },
        getterParams,
        MetricsKind.UNITS,
        undefined,
        undefined,
        disableSiblingOptimization
    );

    if (totalUnits && doors.length > 0) {
        if (totalType === MetricsTotalType.GrandTotalMetric) {
            const deliveriesFromDimension =
                getterParams.context?.tileGridContext?.allocationDimensions?.[0]?.dimension_values;
            if (deliveriesFromDimension) {
                const deliveries = getDeliveriesFromAllocationDimension(deliveriesFromDimension);
                totalLength = deliveries.length * doors.length;
            }
        }
    }
    const averageUnits = safeParseFloat(totalUnits / totalLength, 0);
    const roundedValue = roundValue(averageUnits, 1);
    if (roundedValue === 0) {
        return "";
    }
    return roundedValue;
};
